var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isDesktop)?_c(_setup.CalendarDesktop):_c(_setup.CalendarMobile)
}
var staticRenderFns = []

export { render, staticRenderFns }